export class WidgetLoader {
    static loadWidget(widget, context, options, app) {
        var that = $(context);
        that.data('g6k', app);
        if (widget != null) {
            widget.call(null, that, options, function (value, text, preserveVal, delayed) {
                if (!preserveVal) {
                    that.val(value);
                }
                app.triggerChange(that, delayed);
            });
        }
    }
}